const genreColors = {
	Pop: '#0ca678',
	'Art Pop': '#15aabf',
	Rock: '#ae3ec9',
	Indie: '#d2461a',
	Melankolsk: '#f03e3e',
	Dansk: '#ffd43b',
	Jazz: '#7950f2',
	Metal: '#4c6ef5',
	Cover: '#ced4da',
	Heavy: '#212529',
	Folk: '#15aabf',
};

exports.days = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
exports.months = ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'];

exports.sortGenres = (data) => {
	const count = {};
	data.map((eventContainer) => {
		eventContainer.forEach((event) => {
			const eventGenresString = String(event.genres);
			const eventGenresArray = eventGenresString.split(',');

			for (let i = 0; i < eventGenresArray.length; i++) {
				const genre = eventGenresArray[i].trim().replace(',', '');
				if (count[genre]) {
					count[genre] += 1;
				} else {
					count[genre] = 1;
				}
			}
		});
	});
	const genreArray = Object.entries(count);
	let newGenreArray = genreArray.map((genre) => {
		return {
			genre: genre[0],
			active: false,
			occurences: genre[1],
			color: genreColors[genre[0]] || '#0ca678',
		};
	});
	newGenreArray.sort((a, b) => {
		return b.occurences - a.occurences;
	});
	return newGenreArray;
};

exports.getWelcomeString = () => {
	const newDate = new Date();
	let welcomeString = '';
	if (newDate.getHours() < 5) {
		return (welcomeString = 'Godaften');
	} else if (newDate.getHours() >= 5 && newDate.getHours() < 12) {
		return (welcomeString = 'Godmorgen');
	} else if (newDate.getHours() >= 12 && newDate.getHours() < 18) {
		return (welcomeString = 'God eftermiddag');
	} else {
		return (welcomeString = 'Godaften');
	}
};
